import { host, privateClient } from '.';

const path = '/concedentes';

const getBaseUrl = () => `${host}${path}`;

async function ConsultaConcedentePelaId(id) {
	return await privateClient({
		path: `${path}/${id}`,
	});
}

async function ListaConcedentes() {
	return await privateClient({
		path: `${path}`,
	});
}

async function ListaPropostas() {
	return await privateClient({
		path: `${path}/inativos`,
	});
}

async function AtualizaConcedente(id, dados) {
	return await privateClient({
		path: `${path}/${id}`,
		params: {
			method: 'PUT',
			body: JSON.stringify(dados),
		},
	});
}

async function RemovePropostaPelaId(id) {
	return await privateClient({
		path: `${path}/${id}`,
		params: {
			method: 'DELETE',
		},
	});
}

const concedentes = {
	getBaseUrl,
	ConsultaConcedentePelaId,
	ListaConcedentes,
	ListaPropostas,
	AtualizaConcedente,
	RemovePropostaPelaId,
};

export default concedentes;
